import { useAtomValue } from 'jotai';
import { Suggestions, Value } from '../Suggestions';
import { onFilterChange } from '@src/fragments/Filters/utils/FilterStateUtility';
import { XclusionUtility } from '@src/fragments/Filters/managers/XclusionUtility';
import { productCatalogCountriesInput } from '@src/pages/Discover/components/Selectors/Selectors';
import { useFiltersParams } from '@src/hooks/useFiltersParams';

interface Props {
  availableCountries: string[];
}

export function CatalogCountriesSuggestion({ availableCountries }: Props) {
  const { filters, setFilters } = useFiltersParams();
  const filterProductCatalogCountriesInput = useAtomValue(productCatalogCountriesInput);

  const allCountries: Value[] = availableCountries
    .slice()
    .sort((a, b) => a.localeCompare(b))
    .map((country) => ({
      key: country,
      children: <span>{country}</span>,
    }));

  const rawKeys = XclusionUtility.getRawKeys(filters.productCatalogCountries || []);
  const selectedValues = allCountries.filter((country) => rawKeys.includes(country.key));

  const filteredValues = filterProductCatalogCountriesInput
    ? allCountries.filter((country) =>
      country.key.toLowerCase().includes(filterProductCatalogCountriesInput.toLowerCase())
    )
    : allCountries;

  return (
    <Suggestions
      values={filteredValues}
      selectedValues={selectedValues}
      onChange={onFilterChange(setFilters, 'productCatalogCountries')}
      exclude={false}
    />
  );
}
